import { render, staticRenderFns } from "./DriverSettlementStatCard.vue?vue&type=template&id=511b2efe&"
import script from "./DriverSettlementStatCard.vue?vue&type=script&lang=js&"
export * from "./DriverSettlementStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports